<div class="account-setup">
  <div>
    <div class="col-12">
      <div class="heading">
        <adp-label labelKey="Signup_NewContract_ContractFound_Heading_Text"></adp-label> <mat-icon class="close-icon" (click)="onClose()">close</mat-icon>
      </div>
    </div>
  </div>
  <div class="we-know-you-modal-container">
    <div class="notice">
      <adp-label labelKey="Signup_NewContract_ContractFound_Instruction_Text"></adp-label>
    </div>
    <div class="email">{{emailAddress}}</div>
    <button mat-flat-button color="accent" (click)="redirectToLogin()">
      <adp-label labelKey="Signup_NewContract_ContractFound_LoginButton_Text"></adp-label>
    </button>
    <div class="claim-divider">
      <div class="line">
        <mat-divider></mat-divider>
      </div>
      <div class="text mat-typography">
        <adp-label labelKey="Signup_NewContract_ContractFound_Divider_Text"></adp-label>
      </div>
      <div class="line">
        <mat-divider></mat-divider>
      </div>
    </div>
    <div>
      <adp-label labelKey="Signup_ChangeEmail_Text"></adp-label>
    </div>
  </div>
</div>